export default __webpack_public_path__ + "img/sagoo/sagoo7_480.jpg";